import * as React from 'react';

interface FTimeProps {
  className?: string;
  style?: React.CSSProperties;

  onClick?(): void;
}

/** Figma icon_time 14×14 */
function FTime({ className, style, onClick }: FTimeProps) {
  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path d="M7.4375 6.5625H10.0625V7.4375H6.5625V3.0625H7.4375V6.5625Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7 0.875C3.61726 0.875 0.875 3.61726 0.875 7C0.875 10.3827 3.61726 13.125 7 13.125C10.3827 13.125 13.125 10.3827 13.125 7C13.125 3.61726 10.3827 0.875 7 0.875Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default FTime;
